import { useRouter } from 'next/router';

import { Box, Grid, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { Title } from './style';

import Image from '@components/atoms/image';
import { getNamespaces } from '@helpers/i18nUtils';
import { useDegreeLandingPageData } from '@helpers/use';
import { getImageUrl } from '@helpers/utils';

export const DegreeHighlightSection = () => {
  const router = useRouter();
  const degreeIdName = (router.query.degreeIdName as string) || '';
  const { t } = useTranslation(getNamespaces({ namespaces: [degreeIdName] }));

  const universityId = router.query.universityIdName as string;
  const degreeId = router.query.degreeIdName as string;

  const theme = useTheme();

  const { landingPage } = useDegreeLandingPageData(universityId, degreeId);

  return (
    <Box mb={10}>
      <Title>{t('degree_landing_page.degree_highlight.title')}</Title>
      <Grid container spacing={6}>
        {landingPage?.degreeHighlights?.map((item) => (
          <Grid
            item
            lg={4}
            xs={12}
            key={item.id}
            display="flex"
            flexDirection={{
              xs: 'column',
              md: 'row',
              lg: 'column',
            }}
          >
            <Box
              width={{
                xs: '100%',
                md: 327,
                lg: '100%',
              }}
              height={146}
              mb={{ xs: 3, md: 0, lg: 3 }}
              mr={{ md: 3, lg: 0 }}
              borderRadius="8px"
              overflow="hidden"
              position="relative"
            >
              <Image
                className="img"
                src={getImageUrl(item.imageUrl)}
                alt="Degree highlights"
                style={{ objectFit: 'cover' }}
              />
            </Box>
            <Box flex={1} sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h6_deprecated" color={theme.palette.text.secondary} fontWeight={500}>
                {item.englishTitle}
              </Typography>
              <Typography variant="h5_deprecated">{item.thaiTitle}</Typography>
              <Typography variant="body2_deprecated">{item.detail}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
